// Landing page translations
// Organized by feature: hero, features, accommodations, activities, packages, contact, footer, guestReservation, auth

export const landingTranslations = {
  fr: {
    // Brand
    'landing.brand.name': 'Pourvoirie Nature Pure',
    
    // Navigation
    'landing.navigation.calendars': 'Calendriers',
    'contact': 'Contact',
    
    // Hero Section
    'landing.hero.title': 'Découvrez la Nature Authentique',
    'landing.hero.subtitle': 'Vivez une expérience unique dans nos chalets rustiques et yourtes confortables au cœur de la forêt boréale',
    'landing.hero.explore': 'Explorer nos hébergements',
    'landing.hero.contact': 'Nous contacter',

    // Web-designed home hero (carousel slogans + slide titles; subtitles are photo dates in config)
    'landing.webHero.slogan.line1': 'VIVEZ',
    'landing.webHero.slogan.line2': 'UNE ÉLÉGANCE INÉGALÉE ET',
    'landing.webHero.slide.sunset.title': 'LUXE ET NATURE EN PARFAITE HARMONIE',
    'landing.webHero.slide.lake.title': 'ÉVASION AU BORD DU LAC POUR VOTRE SÉJOUR',
    'landing.webHero.slide.fishgrill.title': 'INSTANTS CULINAIRES EN PLEINE NATURE',
    'landing.webHero.slide.sunrise.title': 'CALME À L\'AUBE, CONFORT HAUT DE GAMME',
    'landing.webHero.slide.milkyway.title': 'NUITS SOUS LA VOIE LACTÉE',
    'landing.webHero.carouselLabel': 'Carrousel photo',
    'landing.webHero.planYourVisit': 'Planifiez votre visite',
    'landing.webHero.nextPhoto': 'Suivant',
    'landing.webHero.prevPhoto': 'Précédent',
    'landing.webHero.bookChooser.title': 'Comment souhaitez-vous réserver ?',
    'landing.webHero.bookChooser.browseStays': 'Parcourir les hébergements',
    'landing.webHero.bookChooser.browseStaysDesc': 'Chalets, yourtes et plus encore',
    'landing.webHero.bookChooser.pickDates': 'Choisir les dates',
    'landing.webHero.bookChooser.pickDatesDesc': 'Voir ce qui est disponible pour votre séjour',
    'landing.webHero.bookChooser.featuredStay': 'Réserver un hébergement vedette',
    'landing.webHero.bookChooser.featuredStayDesc': 'Commencer avec notre sélection',

    // Features Section
    'landing.features.title': 'Pourquoi choisir notre pourvoirie',
    'landing.features.subtitle': 'Une expérience nature authentique avec tout le confort moderne',
    'landing.features.location.desc': 'Située au cœur de la forêt boréale avec accès direct aux lacs privés',
    'landing.features.capacity.desc': 'Hébergements pour 2 à 8 personnes, parfaits pour familles et groupes',
    'landing.features.activities.desc': 'Activités variées : pêche, chasse, randonnée, kayak et plus',
    'landing.features.packages.desc': 'Forfaits tout inclus pour une expérience complète',
    
    // Stays Section
    'landing.stays.title': 'Nos hébergements',
    'landing.stays.subtitle':
      'Du chalet rustique à la yourte en passant par des unités modernes : une gamme complète pour chaque séjour.',
    'landing.stays.viewAll': 'Voir tous les hébergements',
    // Unified accommodations aliases (keep typo alias for compatibility)
    'landing.accommodations.title': 'Nos hébergements',
    'landing.accommodations.subtitle':
      'Du chalet rustique à la yourte en passant par des unités modernes : une gamme complète pour chaque séjour.',
    'landing.accommodations.viewAll': 'Voir tous les hébergements',
    'landing.accomodations.title': 'Nos hébergements',
    'landing.accomodations.subtitle':
      'Du chalet rustique à la yourte en passant par des unités modernes : une gamme complète pour chaque séjour.',
    'landing.accomodations.viewAll': 'Voir tous les hébergements',
    
    // Activities Section
    'landing.activities.title': 'Nos activités',
    'landing.activities.subtitle': 'Découvrez la nature à travers nos activités guidées et en autonomie',
    'landing.activities.viewAll': 'Voir toutes les activités',
    'landing.activities.filterAll': 'Toute l\'année',
    'landing.activities.filterSummer': 'Été',
    'landing.activities.filterWinter': 'Hiver',
    
    // Packages Section
    'landing.packages.title': 'Nos forfaits',
    'landing.packages.subtitle': 'Des expériences complètes pour tous les goûts et toutes les saisons',
    'landing.packages.viewAll': 'Voir tous les forfaits',

    // Map Section
    'landing.map.title': 'Carte',
    'landing.map.subtitle': 'Repérez rapidement nos zones de séjour, pêche et l\'adresse principale.',
    'landing.map.tabFishingSpots': 'Zones de pêche',
    'landing.map.tabStaysSites': 'Sites des hébergements',
    'landing.map.tabFindUs': 'Nous trouver',
    'landing.map.fishingTitle': 'Zones de pêche',
    'landing.map.fishingDesc': 'Zones recommandées pour la pêche guidée et autonome.',
    'landing.map.staysTitle': 'Sites des hébergements',
    'landing.map.staysDesc': 'Zones des chalets, yourtes et unités principales.',
    'landing.map.findUsTitle': 'Nous trouver',
    'landing.map.findUsDesc': 'Adresse principale et accès routier.',

    // Menu Section (landing home)
    'landing.menu.title': 'Menu',
    'landing.menu.subtitle': 'Quelques mets et boissons pour agrémenter votre séjour.',
    'landing.menu.tab.breakfast': 'Déjeuner',
    'landing.menu.tab.lunch': 'Dîner',
    'landing.menu.tab.souper': 'Souper',
    'landing.menu.tab.all': 'Tout',
    'landing.menu.item.forestBreakfast.name': 'Petit-déjeuner en forêt',
    'landing.menu.item.forestBreakfast.desc': 'Œufs, pain du terroir et fruits de saison',
    'landing.menu.item.lakeviewGrill.name': 'Assiette grillée du lac',
    'landing.menu.item.lakeviewGrill.desc': 'Poisson ou poulet grillé avec légumes verts',
    'landing.menu.item.campfireDessert.name': 'Dessert feu de camp',
    'landing.menu.item.campfireDessert.desc': 'Tarte à la guimauve et coulis de petits fruits',
    'landing.menu.item.mapleYogurt.name': 'Bol yogourt à l\'érable',
    'landing.menu.item.mapleYogurt.desc': 'Yogourt, granola et sirop d\'érable',
    'landing.menu.item.trailBurger.name': 'Burger des sentiers',
    'landing.menu.item.trailBurger.desc': 'Burger au bœuf fumé et frites',
    'landing.menu.item.lakeTrout.name': 'Souper truite du lac',
    'landing.menu.item.lakeTrout.desc': 'Truite fraîche avec légumes rôtis',
    
    // Testimonials Section
    'landing.testimonials.title': 'Ce que disent nos clients',
    'landing.testimonials.subtitle': 'Découvrez les témoignages de nos clients satisfaits',
    
    // Contact Section
    'landing.contact.title': 'Contactez-nous',
    'landing.contact.subtitle': 'Coordonnées de la pourvoirie',
    'landing.contact.phone': 'Téléphone',
    'landing.contact.email': 'Courriel',
    'landing.contact.address': 'Adresse',
    'landing.contact.emailValue': 'info@pourvoiriepignonrouge.com',
    'landing.contact.phoneValue': '+1 (450) 833-5083',
    'landing.contact.addressValue': '1 Chemin du Lac Mica, Saint-Michel-des-Saints, QC J0K 3B0',
    'landing.contact.bookNow': 'Réserver maintenant',
    'landing.contact.askQuestion': 'Comment pouvons-nous vous aider ?',

    'landing.gallery.eyebrow': 'Pourvoirie Pignon Rouge',
    'landing.gallery.title': 'Galerie',
    'landing.gallery.subtitle':
      'Un aperçu des lacs, forêts et chalets qui composent notre pourvoirie.',
    'landing.gallery.empty': 'Photos à venir.',
    
    // Footer
    'landing.footer.brandName': 'Pourvoirie Pignon Rouge',
    'landing.footer.description': 'Votre destination nature pour des moments inoubliables en famille ou entre amis.',
    'landing.footer.stays': 'Hébergements',
    'landing.footer.contact': 'Contact',
    'landing.footer.rights': 'Tous droits réservés.',
    
    // Calendars
    'landing.calendars.title': 'Calendriers de disponibilité',
    'landing.calendars.subtitle': 'Consultez la disponibilité en temps réel de nos hébergements et activités',
    'landing.calendars.viewFullPage': 'Voir la page complète',
    
    // Main Calendar Access
    'landing.mainCalendar.title': 'Accès complet aux calendriers',
    'landing.mainCalendar.subtitle': 'Explorez toutes les fonctionnalités de réservation et de planification',
    'landing.mainCalendar.fullCalendar': 'Calendrier principal',
    'landing.mainCalendar.fullCalendarDesc': 'Vue d\'ensemble complète de tous les hébergements et activités',
    'landing.mainCalendar.viewCalendar': 'Voir le calendrier',
    'landing.mainCalendar.stays': 'Hébergements avec calendrier',
    'landing.mainCalendar.staysDesc': 'Gérez vos réservations d\'hébergement avec calendrier intégré',
    'landing.mainCalendar.viewStays': 'Voir les hébergements',
    'landing.mainCalendar.activities': 'Activités avec calendrier',
    'landing.mainCalendar.activitiesDesc': 'Planifiez vos activités avec calendrier de disponibilité',
    'landing.mainCalendar.viewActivities': 'Voir les activités',
    
    // Booking Options
    'landing.bookingOptions.title': 'Options de réservation',
    'landing.bookingOptions.subtitle': 'Choisissez comment vous souhaitez procéder',
    'landing.bookingOptions.login': 'Se connecter et réserver',
    'landing.bookingOptions.guestReservation': 'Réserver en tant qu\'invité',
    'landing.bookingOptions.description': 'Les invités peuvent réserver sans créer de compte',
    
    // Guest Reservation Form
    'guestReservation.title': 'Réservation invité',
    'guestReservation.quickReservation': 'Réservation rapide',
    'guestReservation.personalInfo': 'Informations personnelles',
    'guestReservation.firstName': 'Prénom',
    'guestReservation.lastName': 'Nom',
    'guestReservation.email': 'Email',
    'guestReservation.phone': 'Téléphone',
    'guestReservation.datesAndGuests': 'Dates et invités',
    'guestReservation.dates': 'Dates',
    'guestReservation.checkIn': 'Arrivée',
    'guestReservation.checkOut': 'Départ',
    'guestReservation.duration': 'Durée',
    'guestReservation.night': 'nuit',
    'guestReservation.nights': 'nuits',
    'guestReservation.useCheckOut': 'Utiliser date de départ',
    'guestReservation.useDuration': 'Utiliser durée',
    'guestReservation.guests': 'Invités',
    'guestReservation.activityDetails': 'Détails de l\'activité',
    'guestReservation.preferredDate': 'Date préférée',
    'guestReservation.participants': 'Participants',
    'guestReservation.adults': 'Adultes',
    'guestReservation.children': 'Enfants',
    'guestReservation.specialRequests': 'Demandes spéciales',
    'guestReservation.specialRequestsPlaceholder': 'Avez-vous des demandes particulières?',
    'guestReservation.paymentMethod': 'Méthode de paiement',
    'guestReservation.creditCard': 'Carte de crédit',
    'guestReservation.debitCard': 'Carte de débit',
    'guestReservation.paypal': 'PayPal',
    'guestReservation.downpayment': 'Acompte de 35%',
    'guestReservation.cashOnArrival': 'Paiement à l\'arrivée',
    'guestReservation.total': 'Total',
    'guestReservation.submitReservation': 'Soumettre la réservation',
    'guestReservation.confirmation.title': 'Réservation confirmée!',
    'guestReservation.confirmation.subtitle': 'Votre réservation a été soumise avec succès',
    'guestReservation.confirmation.reservationDetails': 'Détails de la réservation',
    'guestReservation.confirmation.reservationId': 'Numéro de réservation',
    'guestReservation.confirmation.guestInfo': 'Informations invité',
    'guestReservation.confirmation.specialRequests': 'Demandes spéciales',
    'guestReservation.confirmation.statusMessage': 'Votre réservation est en attente de confirmation. Vous recevrez un email de confirmation sous peu.',
    'guestReservation.confirmation.backToHome': 'Retour à l\'accueil',
    'guestReservation.paymentMode': 'Mode de paiement',
    'guestReservation.payAsGuest': 'Payer en tant qu\'invité',
    'guestReservation.payAsGuestDesc': 'Réservation sans compte',
    'guestReservation.payAsMember': 'Payer en tant que membre',
    'guestReservation.payAsMemberDesc': 'Connectez-vous pour réserver',
    'guestReservation.memberLogin': 'Connexion membre',
    'guestReservation.password': 'Mot de passe',
    'guestReservation.emailPlaceholder': 'votre@email.com',
    'guestReservation.passwordPlaceholder': '••••••••',
    'guestReservation.loginErrorRequired': 'Veuillez remplir tous les champs',
    'guestReservation.loginErrorInvalid': 'Identifiants invalides',
    'guestReservation.loggedInAs': 'Connecté en tant que',
    'guestReservation.demoAccount': 'Compte de démonstration',
    'guestReservation.timeExpired': 'Le temps est écoulé! Veuillez recommencer votre réservation.',
    'guestReservation.couponCode': 'Code promotionnel',
    'guestReservation.couponCodePlaceholder': 'Entrez votre code...',
    'guestReservation.applyCoupon': 'Appliquer',
    'guestReservation.couponUnknown': 'Ce code promotionnel n’est pas reconnu.',
    'guestReservation.recommendations': 'Forfaits suggérés',
    'guestReservation.recommendationsDescription': 'Complétez votre séjour avec ces forfaits avantageux',
    'guestReservation.addToBooking': 'Ajouter à ma réservation',
    'guestReservation.discount': 'de rabais',
    'guestReservation.fromShoppingAssistant': 'Dates provenant de l\'assistant de réservation',
    'guestReservation.packageIncludes': 'Inclut',
    'guestReservation.packageNights': '{n} nuit(s) de chalet',
    'guestReservation.packageActivity': '+ activité',
    'guestReservation.promoContactTitle': 'Vous avez un forfait avec code de promotion ?',
    'guestReservation.promoContactDesc': 'Si vous avez déjà payé un forfait via un code promotionnel, contactez-nous directement pour confirmer votre séjour.',
    'guestReservation.promoContactCta': 'Contactez-nous pour confirmer',
    
    // Sign In
    'signIn.title': 'Se connecter',
    'signIn.button': 'Se connecter',
    'signIn.email': 'Courriel',
    'signIn.emailRequired': 'Le courriel est requis',
    'signIn.emailInvalid': 'Le courriel est invalide',
    'signIn.emailPlaceholder': 'Entrez votre courriel',
    'signIn.password': 'Mot de passe',
    'signIn.passwordRequired': 'Le mot de passe est requis',
    'signIn.passwordPlaceholder': 'Entrez votre mot de passe',
    'signIn.verificationCode': 'Code de vérification',
    'signIn.codeRequired': 'Le code de vérification est requis',
    'signIn.codePlaceholder': 'Entrez le code de vérification',
    'signIn.codeSent': 'Code de vérification envoyé à votre courriel',
    'signIn.sendCode': 'Envoyer le code de vérification',
    'signIn.forgotPassword': 'Mot de passe oublié?',
    'signIn.codeToEmail': 'Code par courriel',
    'signIn.signWithPassword': 'Connexion par mot de passe',
    'signIn.invalidCredentials': 'Email ou mot de passe invalide',
    'signIn.confirmation.title': 'Bienvenue de retour!',
    'signIn.confirmation.subtitle': 'Bienvenue de retour, {firstName}!',
    'signIn.confirmation.loggedInAs': 'Connecté en tant que',
    'signIn.confirmation.redirecting': 'Redirection...',
    
    // Sign Up
    'signUp.title': 'S\'inscrire',
    'signUp.button': 'S\'inscrire',
    'signUp.email': 'Courriel',
    'signUp.emailRequired': 'Le courriel est requis',
    'signUp.emailInvalid': 'Le courriel est invalide',
    'signUp.emailPlaceholder': 'Entrez votre courriel',
    'signUp.phone': 'Téléphone',
    'signUp.phoneRequired': 'Le téléphone est requis',
    'signUp.phoneInvalid': 'Le téléphone est invalide',
    'signUp.phonePlaceholder': 'Entrez votre numéro de téléphone',
    'signUp.password': 'Mot de passe',
    'signUp.passwordRequired': 'Le mot de passe est requis',
    'signUp.passwordMinLength': 'Le mot de passe doit contenir au moins 8 caractères',
    'signUp.passwordPlaceholder': 'Entrez votre mot de passe',
    'signUp.confirmPassword': 'Confirmer le mot de passe',
    'signUp.confirmPasswordRequired': 'Veuillez confirmer votre mot de passe',
    'signUp.confirmPasswordPlaceholder': 'Confirmez votre mot de passe',
    'signUp.passwordsDoNotMatch': 'Les mots de passe ne correspondent pas',
    'signUp.verificationCode': 'Code de vérification',
    'signUp.codeRequired': 'Le code de vérification est requis',
    'signUp.codePlaceholder': 'Entrez le code de vérification',
    'signUp.codeSent': 'Code de vérification envoyé à votre courriel',
    'signUp.sendCode': 'Envoyer le code de vérification',
    'signUp.sendCodeFirst': 'Veuillez d\'abord envoyer le code de vérification',
    'signUp.codeDescription': 'Un code de vérification sera envoyé à votre courriel pour confirmer votre inscription',
    
    // Auth (shared with signUp/signIn)
    'auth.firstName': 'Prénom',
    'auth.firstNameRequired': 'Le prénom est requis',
    'auth.firstNamePlaceholder': 'Entrez votre prénom',
    'auth.lastName': 'Nom',
    'auth.lastNameRequired': 'Le nom est requis',
    'auth.lastNamePlaceholder': 'Entrez votre nom',
    
    // Sign Up Confirmation
    'signUp.confirmation.title': 'Compte créé avec succès!',
    'signUp.confirmation.subtitle': 'Bienvenue à Pourvoirie Pignon Rouge!',
    'signUp.confirmation.welcome': 'Bienvenue',
    'signUp.confirmation.redirecting': 'Redirection vers votre compte...',
  },
  en: {
    // Brand
    'landing.brand.name': 'Pure Nature Lodge',
    
    // Navigation
    'landing.navigation.calendars': 'Calendars',
    'contact': 'Contact',
    
    // Hero Section
    'landing.hero.title': 'Discover Authentic Nature',
    'landing.hero.subtitle': 'Experience a unique stay in our rustic cabins and comfortable yurts in the heart of the boreal forest',
    'landing.hero.explore': 'Explore our accommodations',
    'landing.hero.contact': 'Contact us',

    // Web-designed home hero (carousel)
    'landing.webHero.slogan.line1': 'EXPERIENCE',
    'landing.webHero.slogan.line2': 'UNMATCHED ELEGANCE AND',
    'landing.webHero.slide.sunset.title': 'LUXURY AND NATURE IN PERFECT HARMONY',
    'landing.webHero.slide.lake.title': 'LAKEFRONT ESCAPE FOR YOUR NEXT STAY',
    'landing.webHero.slide.fishgrill.title': 'CULINARY MOMENTS IN THE WILDERNESS',
    'landing.webHero.slide.sunrise.title': 'SUNRISE CALM, ELEVATED COMFORT',
    'landing.webHero.slide.milkyway.title': 'NIGHTS UNDER THE MILKY WAY',
    'landing.webHero.carouselLabel': 'Photo carousel',
    'landing.webHero.planYourVisit': 'Plan your visit',
    'landing.webHero.nextPhoto': 'Next',
    'landing.webHero.prevPhoto': 'Previous',
    'landing.webHero.bookChooser.title': 'How would you like to book?',
    'landing.webHero.bookChooser.browseStays': 'Browse stays',
    'landing.webHero.bookChooser.browseStaysDesc': 'See cabins, yurts, and more',
    'landing.webHero.bookChooser.pickDates': 'Pick dates',
    'landing.webHero.bookChooser.pickDatesDesc': 'Find what is available for your trip',
    'landing.webHero.bookChooser.featuredStay': 'Book a featured stay',
    'landing.webHero.bookChooser.featuredStayDesc': 'Start with our top pick',

    // Features Section
    'landing.features.title': 'Why choose our lodge',
    'landing.features.subtitle': 'An authentic nature experience with all modern comforts',
    'landing.features.location.desc': 'Located in the heart of the boreal forest with direct access to private lakes',
    'landing.features.capacity.desc': 'Accommodations for 2 to 8 people, perfect for families and groups',
    'landing.features.activities.desc': 'Varied activities: fishing, hunting, hiking, kayaking and more',
    'landing.features.packages.desc': 'All-inclusive packages for a complete experience',
    
    // Stays Section
    'landing.stays.title': 'Our accommodations',
    'landing.stays.subtitle':
      'Rustic cabins, yurts, modern lodging, and more—pick the stay that fits your trip.',
    'landing.stays.viewAll': 'View all accommodations',
    // Unified accommodations aliases (keep typo alias for compatibility)
    'landing.accommodations.title': 'Our accommodations',
    'landing.accommodations.subtitle':
      'Rustic cabins, yurts, modern lodging, and more—pick the stay that fits your trip.',
    'landing.accommodations.viewAll': 'View all accommodations',
    'landing.accomodations.title': 'Our accommodations',
    'landing.accomodations.subtitle':
      'Rustic cabins, yurts, modern lodging, and more—pick the stay that fits your trip.',
    'landing.accomodations.viewAll': 'View all accommodations',
    
    // Activities Section
    'landing.activities.title': 'Our activities',
    'landing.activities.subtitle': 'Discover nature through our guided and self-guided activities',
    'landing.activities.viewAll': 'View all activities',
    'landing.activities.filterAll': 'All year',
    'landing.activities.filterSummer': 'Summer',
    'landing.activities.filterWinter': 'Winter',
    
    // Packages Section
    'landing.packages.title': 'Our packages',
    'landing.packages.subtitle': 'Complete experiences for all tastes and seasons',
    'landing.packages.viewAll': 'View all packages',

    // Map Section
    'landing.map.title': 'Map',
    'landing.map.subtitle': 'Quickly locate our stays, fishing areas, and main address.',
    'landing.map.tabFishingSpots': 'Fishing spots',
    'landing.map.tabStaysSites': 'Stays sites',
    'landing.map.tabFindUs': 'Find us',
    'landing.map.fishingTitle': 'Fishing spots',
    'landing.map.fishingDesc': 'Recommended zones for guided and self-service fishing.',
    'landing.map.staysTitle': 'Stays sites',
    'landing.map.staysDesc': 'Main chalet, yurt and unit locations.',
    'landing.map.findUsTitle': 'Find us',
    'landing.map.findUsDesc': 'Main address and road access.',

    // Menu Section (landing home)
    'landing.menu.title': 'Menu',
    'landing.menu.subtitle': 'Food and beverage highlights for guests during their stay.',
    'landing.menu.tab.breakfast': 'Breakfast',
    'landing.menu.tab.lunch': 'Lunch',
    'landing.menu.tab.souper': 'Dinner',
    'landing.menu.tab.all': 'All',
    'landing.menu.item.forestBreakfast.name': 'Forest Breakfast',
    'landing.menu.item.forestBreakfast.desc': 'Eggs, local bread, seasonal fruits',
    'landing.menu.item.lakeviewGrill.name': 'Lakeview Grill Plate',
    'landing.menu.item.lakeviewGrill.desc': 'Grilled fish or chicken with greens',
    'landing.menu.item.campfireDessert.name': 'Campfire Dessert',
    'landing.menu.item.campfireDessert.desc': 'Marshmallow tart and berry coulis',
    'landing.menu.item.mapleYogurt.name': 'Maple Yogurt Bowl',
    'landing.menu.item.mapleYogurt.desc': 'Yogurt, granola and maple syrup',
    'landing.menu.item.trailBurger.name': 'Trail Burger',
    'landing.menu.item.trailBurger.desc': 'Smoked beef burger and fries',
    'landing.menu.item.lakeTrout.name': 'Lake Trout Dinner',
    'landing.menu.item.lakeTrout.desc': 'Fresh trout with roasted vegetables',
    
    // Testimonials Section
    'landing.testimonials.title': 'What our clients say',
    'landing.testimonials.subtitle': 'Discover testimonials from our satisfied clients',
    
    // Contact Section
    'landing.contact.title': 'Contact us',
    'landing.contact.subtitle': 'Outfitter contact information',
    'landing.contact.phone': 'Phone',
    'landing.contact.email': 'Email',
    'landing.contact.address': 'Address',
    'landing.contact.emailValue': 'info@pourvoiriepignonrouge.com',
    'landing.contact.phoneValue': '+1 (450) 833-5083',
    'landing.contact.addressValue': '1 Chemin du Lac Mica, Saint-Michel-des-Saints, QC J0K 3B0',
    'landing.contact.bookNow': 'Book now',
    'landing.contact.askQuestion': 'How can we help?',

    'landing.gallery.eyebrow': 'Pourvoirie Pignon Rouge',
    'landing.gallery.title': 'Gallery',
    'landing.gallery.subtitle':
      'A glimpse of the lakes, forests, and cabins that make up our pourvoirie.',
    'landing.gallery.empty': 'Photos coming soon.',
    
    // Footer
    'landing.footer.brandName': 'Pourvoirie Pignon Rouge',
    'landing.footer.description': 'Your nature destination for unforgettable moments with family or friends.',
    'landing.footer.stays': 'Accommodations',
    'landing.footer.contact': 'Contact',
    'landing.footer.rights': 'All rights reserved.',
    
    // Calendars
    'landing.calendars.title': 'Availability Calendars',
    'landing.calendars.subtitle': 'Check real-time availability of our accommodations and activities',
    'landing.calendars.viewFullPage': 'View Full Page',
    
    // Main Calendar Access
    'landing.mainCalendar.title': 'Complete Calendar Access',
    'landing.mainCalendar.subtitle': 'Explore all booking and planning features',
    'landing.mainCalendar.fullCalendar': 'Main Calendar',
    'landing.mainCalendar.fullCalendarDesc': 'Complete overview of all accommodations and activities',
    'landing.mainCalendar.viewCalendar': 'View Calendar',
    'landing.mainCalendar.stays': 'Accommodations with Calendar',
    'landing.mainCalendar.staysDesc': 'Manage your accommodation bookings with integrated calendar',
    'landing.mainCalendar.viewStays': 'View Accommodations',
    'landing.mainCalendar.activities': 'Activities with Calendar',
    'landing.mainCalendar.activitiesDesc': 'Plan your activities with availability calendar',
    'landing.mainCalendar.viewActivities': 'View Activities',
    
    // Booking Options
    'landing.bookingOptions.title': 'Booking Options',
    'landing.bookingOptions.subtitle': 'Choose how you would like to proceed',
    'landing.bookingOptions.login': 'Login and Book',
    'landing.bookingOptions.guestReservation': 'Book as Guest',
    'landing.bookingOptions.description': 'Guests can book without creating an account',
    
    // Guest Reservation Form
    'guestReservation.title': 'Guest Reservation',
    'guestReservation.quickReservation': 'Quick Reservation',
    'guestReservation.personalInfo': 'Personal Information',
    'guestReservation.firstName': 'First Name',
    'guestReservation.lastName': 'Last Name',
    'guestReservation.email': 'Email',
    'guestReservation.phone': 'Phone',
    'guestReservation.datesAndGuests': 'Dates and Guests',
    'guestReservation.dates': 'Dates',
    'guestReservation.checkIn': 'Check-in',
    'guestReservation.checkOut': 'Check-out',
    'guestReservation.duration': 'Duration',
    'guestReservation.night': 'night',
    'guestReservation.nights': 'nights',
    'guestReservation.useCheckOut': 'Use check-out date',
    'guestReservation.useDuration': 'Use duration',
    'guestReservation.guests': 'Guests',
    'guestReservation.activityDetails': 'Activity Details',
    'guestReservation.preferredDate': 'Preferred Date',
    'guestReservation.participants': 'Participants',
    'guestReservation.adults': 'Adults',
    'guestReservation.children': 'Children',
    'guestReservation.specialRequests': 'Special Requests',
    'guestReservation.specialRequestsPlaceholder': 'Do you have any special requests?',
    'guestReservation.paymentMethod': 'Payment Method',
    'guestReservation.creditCard': 'Credit Card',
    'guestReservation.debitCard': 'Debit Card',
    'guestReservation.paypal': 'PayPal',
    'guestReservation.downpayment': '35% Downpayment Reservation',
    'guestReservation.cashOnArrival': 'Cash on Arrival',
    'guestReservation.total': 'Total',
    'guestReservation.submitReservation': 'Submit Reservation',
    'guestReservation.paymentMode': 'Payment Mode',
    'guestReservation.payAsGuest': 'Pay as Guest',
    'guestReservation.payAsGuestDesc': 'Reserve without account',
    'guestReservation.payAsMember': 'Pay as Member',
    'guestReservation.payAsMemberDesc': 'Login to make reservation',
    'guestReservation.memberLogin': 'Member Login',
    'guestReservation.password': 'Password',
    'guestReservation.emailPlaceholder': 'your@email.com',
    'guestReservation.passwordPlaceholder': '••••••••',
    'guestReservation.loginErrorRequired': 'Please fill in all fields',
    'guestReservation.loginErrorInvalid': 'Invalid credentials',
    'guestReservation.loggedInAs': 'Logged in as',
    'guestReservation.demoAccount': 'Demo Account',
    'guestReservation.timeExpired': 'Time expired! Please restart your reservation.',
    'guestReservation.couponCode': 'Promo Code',
    'guestReservation.couponCodePlaceholder': 'Enter your code...',
    'guestReservation.applyCoupon': 'Apply',
    'guestReservation.couponUnknown': 'This promo code is not recognized.',
    'guestReservation.recommendations': 'Suggested Packages',
    'guestReservation.recommendationsDescription': 'Complete your stay with these great packages',
    'guestReservation.addToBooking': 'Add to my booking',
    'guestReservation.discount': 'off',
    'guestReservation.fromShoppingAssistant': 'Dates from booking assistant',
    'guestReservation.packageIncludes': 'Includes',
    'guestReservation.packageNights': '{n} night(s) of chalet',
    'guestReservation.packageActivity': '+ activity',
    'guestReservation.promoContactTitle': 'Do you have a package with a promo code?',
    'guestReservation.promoContactDesc': 'If you already paid for a package via a promotional code, contact us directly to confirm your stay.',
    'guestReservation.promoContactCta': 'Contact us to confirm',

    // Sign In
    'signIn.title': 'Sign In',
    'signIn.button': 'Sign In',
    'signIn.email': 'Email',
    'signIn.emailRequired': 'Email is required',
    'signIn.emailInvalid': 'Email is invalid',
    'signIn.emailPlaceholder': 'Enter your email',
    'signIn.password': 'Password',
    'signIn.passwordRequired': 'Password is required',
    'signIn.passwordPlaceholder': 'Enter your password',
    'signIn.verificationCode': 'Verification Code',
    'signIn.codeRequired': 'Verification code is required',
    'signIn.codePlaceholder': 'Enter the verification code',
    'signIn.codeSent': 'Verification code sent to your email',
    'signIn.sendCode': 'Send Verification Code',
    'signIn.forgotPassword': 'Forgot Password?',
    'signIn.codeToEmail': 'Email Verification Code',
    'signIn.signWithPassword': 'Sign In with Password',
    'signIn.invalidCredentials': 'Invalid email or password',
    'signIn.confirmation.title': 'Welcome Back!',
    'signIn.confirmation.subtitle': 'Welcome back, {firstName}!',
    'signIn.confirmation.loggedInAs': 'Logged in as',
    'signIn.confirmation.redirecting': 'Redirecting...',
    
    // Sign Up
    'signUp.title': 'Sign Up',
    'signUp.button': 'Sign Up',
    'signUp.email': 'Email',
    'signUp.emailRequired': 'Email is required',
    'signUp.emailInvalid': 'Email is invalid',
    'signUp.emailPlaceholder': 'Enter your email',
    'signUp.phone': 'Phone',
    'signUp.phoneRequired': 'Phone is required',
    'signUp.phoneInvalid': 'Phone is invalid',
    'signUp.phonePlaceholder': 'Enter your phone number',
    'signUp.password': 'Password',
    'signUp.passwordRequired': 'Password is required',
    'signUp.passwordMinLength': 'Password must be at least 8 characters',
    'signUp.passwordPlaceholder': 'Enter your password',
    'signUp.confirmPassword': 'Confirm Password',
    'signUp.confirmPasswordRequired': 'Please confirm your password',
    'signUp.confirmPasswordPlaceholder': 'Confirm your password',
    'signUp.passwordsDoNotMatch': 'Passwords do not match',
    'signUp.verificationCode': 'Verification Code',
    'signUp.codeRequired': 'Verification code is required',
    'signUp.codePlaceholder': 'Enter the verification code',
    'signUp.codeSent': 'Verification code sent to your email',
    'signUp.sendCode': 'Send Verification Code',
    'signUp.sendCodeFirst': 'Please send verification code first',
    'signUp.codeDescription': 'A verification code will be sent to your email to confirm your registration',
    
    // Auth (shared with signUp/signIn)
    'auth.firstName': 'First Name',
    'auth.firstNameRequired': 'First name is required',
    'auth.firstNamePlaceholder': 'Enter your first name',
    'auth.lastName': 'Last Name',
    'auth.lastNameRequired': 'Last name is required',
    'auth.lastNamePlaceholder': 'Enter your last name',
    
    // Sign Up Confirmation
    'signUp.confirmation.title': 'Account Created Successfully!',
    'signUp.confirmation.subtitle': 'Welcome to Pourvoirie Pignon Rouge!',
    'signUp.confirmation.welcome': 'Welcome',
    'signUp.confirmation.redirecting': 'Redirecting to your account...',
  },
  zh: {
    // Brand
    'landing.brand.name': '纯自然小屋',
    
    // Navigation
    'landing.navigation.calendars': '日历',
    'contact': '联系',
    
    // Hero Section
    'landing.hero.title': '发现真正的自然',
    'landing.hero.subtitle': '在我们位于北方森林中心的质朴小屋和舒适蒙古包中体验独特的住宿',
    'landing.hero.explore': '探索我们的住宿',
    'landing.hero.contact': '联系我们',

    'landing.webHero.slogan.line1': '体验',
    'landing.webHero.slogan.line2': '无与伦比的优雅与',
    'landing.webHero.slide.sunset.title': '自然与奢华和谐相融',
    'landing.webHero.slide.lake.title': '湖畔度假之选',
    'landing.webHero.slide.fishgrill.title': '野外的味觉时刻',
    'landing.webHero.slide.sunrise.title': '日出宁静，尊享舒适',
    'landing.webHero.slide.milkyway.title': '银河下的夜晚',
    'landing.webHero.carouselLabel': '图片轮播',
    'landing.webHero.planYourVisit': '规划您的行程',
    'landing.webHero.nextPhoto': '下一张',
    'landing.webHero.prevPhoto': '上一张',
    'landing.webHero.bookChooser.title': '您想如何预订？',
    'landing.webHero.bookChooser.browseStays': '浏览住宿',
    'landing.webHero.bookChooser.browseStaysDesc': '木屋、蒙古包等',
    'landing.webHero.bookChooser.pickDates': '选择日期',
    'landing.webHero.bookChooser.pickDatesDesc': '查看您行程的可用房源',
    'landing.webHero.bookChooser.featuredStay': '预订精选住宿',
    'landing.webHero.bookChooser.featuredStayDesc': '从我们的推荐开始',

    // Features Section
    'landing.features.title': '为什么选择我们的小屋',
    'landing.features.subtitle': '真正的自然体验，拥有所有现代舒适设施',
    'landing.features.location.desc': '位于北方森林中心，可直接进入私人湖泊',
    'landing.features.capacity.desc': '2至8人的住宿，完美适合家庭和团体',
    'landing.features.activities.desc': '多样活动：钓鱼、狩猎、徒步、皮划艇等',
    'landing.features.packages.desc': '全包套餐，提供完整体验',
    
    // Accommodations Section
    'landing.stays.title': '我们的住宿',
    'landing.stays.subtitle': '从小屋、蒙古包到现代客房——多种住宿选择，不限于三种房型。',
    'landing.stays.viewAll': '查看所有住宿',
    // Unified accommodations aliases (keep typo alias for compatibility)
    'landing.accommodations.title': '我们的住宿',
    'landing.accommodations.subtitle': '从小屋、蒙古包到现代客房——多种住宿选择，不限于三种房型。',
    'landing.accommodations.viewAll': '查看所有住宿',
    'landing.accomodations.title': '我们的住宿',
    'landing.accomodations.subtitle': '从小屋、蒙古包到现代客房——多种住宿选择，不限于三种房型。',
    'landing.accomodations.viewAll': '查看所有住宿',
    
    // Activities Section
    'landing.activities.title': '我们的活动',
    'landing.activities.subtitle': '通过我们的导游和自助活动发现自然',
    'landing.activities.viewAll': '查看所有活动',
    'landing.activities.filterAll': '全年',
    'landing.activities.filterSummer': '夏季',
    'landing.activities.filterWinter': '冬季',
    
    // Packages Section
    'landing.packages.title': '我们的套餐',
    'landing.packages.subtitle': '适合所有口味和季节的完整体验',
    'landing.packages.viewAll': '查看所有套餐',

    // Map Section
    'landing.map.title': '地图',
    'landing.map.subtitle': '快速定位住宿区域、钓鱼点和主地址。',
    'landing.map.tabFishingSpots': '钓鱼点',
    'landing.map.tabStaysSites': '住宿区域',
    'landing.map.tabFindUs': '找到我们',
    'landing.map.fishingTitle': '钓鱼点',
    'landing.map.fishingDesc': '推荐的导钓与自由钓区域。',
    'landing.map.staysTitle': '住宿区域',
    'landing.map.staysDesc': '主要木屋、蒙古包和住宿点位。',
    'landing.map.findUsTitle': '找到我们',
    'landing.map.findUsDesc': '主地址与道路访问方式。',

    // Menu Section (landing home)
    'landing.menu.title': '菜单',
    'landing.menu.subtitle': '入住期间为您精选的餐饮亮点。',
    'landing.menu.tab.breakfast': '早餐',
    'landing.menu.tab.lunch': '午餐',
    'landing.menu.tab.souper': '晚餐',
    'landing.menu.tab.all': '全部',
    'landing.menu.item.forestBreakfast.name': '森林早餐',
    'landing.menu.item.forestBreakfast.desc': '鸡蛋、本地面包与时令水果',
    'landing.menu.item.lakeviewGrill.name': '湖景烤盘',
    'landing.menu.item.lakeviewGrill.desc': '烤鱼或烤鸡配蔬菜',
    'landing.menu.item.campfireDessert.name': '篝火甜品',
    'landing.menu.item.campfireDessert.desc': '棉花糖挞配莓果酱汁',
    'landing.menu.item.mapleYogurt.name': '枫糖酸奶碗',
    'landing.menu.item.mapleYogurt.desc': '酸奶、格兰诺拉与枫糖浆',
    'landing.menu.item.trailBurger.name': '小径汉堡',
    'landing.menu.item.trailBurger.desc': '烟熏牛肉汉堡配薯条',
    'landing.menu.item.lakeTrout.name': '湖鳟晚餐',
    'landing.menu.item.lakeTrout.desc': '新鲜鳟鱼配烤蔬菜',
    
    // Testimonials Section
    'landing.testimonials.title': '客户评价',
    'landing.testimonials.subtitle': '发现我们满意客户的见证',
    
    // Contact Section
    'landing.contact.title': '联系我们',
    'landing.contact.subtitle': '度假营地联系方式',
    'landing.contact.phone': '电话',
    'landing.contact.email': '邮箱',
    'landing.contact.address': '地址',
    'landing.contact.emailValue': 'info@pourvoiriepignonrouge.com',
    'landing.contact.phoneValue': '+1 (450) 833-5083',
    'landing.contact.addressValue': '1 Chemin du Lac Mica, Saint-Michel-des-Saints, QC J0K 3B0',
    'landing.contact.bookNow': '立即预订',
    'landing.contact.askQuestion': '我们如何帮助您？',

    'landing.gallery.eyebrow': 'Pourvoirie Pignon Rouge',
    'landing.gallery.title': '相册',
    'landing.gallery.subtitle': '湖光、森林与小屋——我们度假营地的一瞥。',
    'landing.gallery.empty': '照片即将上线。',
    
    // Footer
    'landing.footer.brandName': 'Pourvoirie Pignon Rouge',
    'landing.footer.description': '您与家人或朋友共度难忘时光的自然目的地。',
    'landing.footer.stays': '住宿',
    'landing.footer.contact': '联系',
    'landing.footer.rights': '版权所有。',
    
    // Calendars
    'landing.calendars.title': '可用性日历',
    'landing.calendars.subtitle': '查看我们住宿和活动的实时可用性',
    'landing.calendars.viewFullPage': '查看完整页面',
    
    // Main Calendar Access
    'landing.mainCalendar.title': '完整日历访问',
    'landing.mainCalendar.subtitle': '探索所有预订和规划功能',
    'landing.mainCalendar.fullCalendar': '主日历',
    'landing.mainCalendar.fullCalendarDesc': '所有住宿和活动的完整概览',
    'landing.mainCalendar.viewCalendar': '查看日历',
    'landing.mainCalendar.stays': '带日历的住宿',
    'landing.mainCalendar.staysDesc': '使用集成日历管理您的住宿预订',
    'landing.mainCalendar.viewStays': '查看住宿',
    'landing.mainCalendar.activities': '带日历的活动',
    'landing.mainCalendar.activitiesDesc': '使用可用性日历规划您的活动',
    'landing.mainCalendar.viewActivities': '查看活动',
    
    // Booking Options
    'landing.bookingOptions.title': '预订选项',
    'landing.bookingOptions.subtitle': '选择您希望如何进行',
    'landing.bookingOptions.login': '登录并预订',
    'landing.bookingOptions.guestReservation': '以访客身份预订',
    'landing.bookingOptions.description': '访客可以在不创建账户的情况下预订',
    
    // Guest Reservation Form
    'guestReservation.title': '访客预订',
    'guestReservation.quickReservation': '快速预订',
    'guestReservation.personalInfo': '个人信息',
    'guestReservation.firstName': '名字',
    'guestReservation.lastName': '姓氏',
    'guestReservation.email': '邮箱',
    'guestReservation.phone': '电话',
    'guestReservation.datesAndGuests': '日期和客人',
    'guestReservation.dates': '日期',
    'guestReservation.checkIn': '入住',
    'guestReservation.checkOut': '退房',
    'guestReservation.duration': '时长',
    'guestReservation.night': '晚',
    'guestReservation.nights': '晚',
    'guestReservation.useCheckOut': '使用退房日期',
    'guestReservation.useDuration': '使用时长',
    'guestReservation.guests': '客人',
    'guestReservation.activityDetails': '活动详情',
    'guestReservation.preferredDate': '首选日期',
    'guestReservation.participants': '参与者',
    'guestReservation.adults': '成人',
    'guestReservation.children': '儿童',
    'guestReservation.specialRequests': '特殊要求',
    'guestReservation.specialRequestsPlaceholder': '您有什么特殊要求吗？',
    'guestReservation.paymentMethod': '付款方式',
    'guestReservation.creditCard': '信用卡',
    'guestReservation.debitCard': '借记卡',
    'guestReservation.paypal': 'PayPal',
    'guestReservation.downpayment': '35% 首付预订',
    'guestReservation.cashOnArrival': '到店付款',
    'guestReservation.total': '总计',
    'guestReservation.submitReservation': '提交预订',
    'guestReservation.paymentMode': '付款模式',
    'guestReservation.payAsGuest': '以访客身份付款',
    'guestReservation.payAsGuestDesc': '无需账户即可预订',
    'guestReservation.payAsMember': '以会员身份付款',
    'guestReservation.payAsMemberDesc': '登录以进行预订',
    'guestReservation.memberLogin': '会员登录',
    'guestReservation.password': '密码',
    'guestReservation.emailPlaceholder': 'your@email.com',
    'guestReservation.passwordPlaceholder': '••••••••',
    'guestReservation.loginErrorRequired': '请填写所有字段',
    'guestReservation.loginErrorInvalid': '凭据无效',
    'guestReservation.loggedInAs': '已登录为',
    'guestReservation.demoAccount': '演示账户',
    'guestReservation.timeExpired': '时间已到！请重新开始您的预订。',
    'guestReservation.couponCode': '促销代码',
    'guestReservation.couponCodePlaceholder': '输入代码…',
    'guestReservation.applyCoupon': '应用',
    'guestReservation.couponUnknown': '此促销代码无效。',
    
    // Sign In
    'signIn.title': '登录',
    'signIn.button': '登录',
    'signIn.email': '邮箱',
    'signIn.emailRequired': '邮箱是必填项',
    'signIn.emailInvalid': '邮箱格式无效',
    'signIn.emailPlaceholder': '请输入您的邮箱',
    'signIn.password': '密码',
    'signIn.passwordRequired': '密码是必填项',
    'signIn.passwordPlaceholder': '请输入您的密码',
    'signIn.verificationCode': '验证码',
    'signIn.codeRequired': '验证码是必填项',
    'signIn.codePlaceholder': '请输入验证码',
    'signIn.codeSent': '验证码已发送到您的邮箱',
    'signIn.sendCode': '发送验证码',
    'signIn.forgotPassword': '忘记密码？',
    'signIn.codeToEmail': '邮箱验证码登录',
    'signIn.signWithPassword': '密码登录',
    'signIn.invalidCredentials': '邮箱或密码无效',
    'signIn.confirmation.title': '欢迎回来！',
    'signIn.confirmation.subtitle': '欢迎回来，{firstName}！',
    'signIn.confirmation.loggedInAs': '已登录为',
    'signIn.confirmation.redirecting': '正在跳转...',
    
    // Sign Up
    'signUp.title': '注册',
    'signUp.button': '注册',
    'signUp.email': '邮箱',
    'signUp.emailRequired': '邮箱是必填项',
    'signUp.emailInvalid': '邮箱格式无效',
    'signUp.emailPlaceholder': '请输入您的邮箱',
    'signUp.phone': '电话',
    'signUp.phoneRequired': '电话是必填项',
    'signUp.phoneInvalid': '电话格式无效',
    'signUp.phonePlaceholder': '请输入您的电话号码',
    'signUp.password': '密码',
    'signUp.passwordRequired': '密码是必填项',
    'signUp.passwordMinLength': '密码至少需要8个字符',
    'signUp.passwordPlaceholder': '请输入您的密码',
    'signUp.confirmPassword': '确认密码',
    'signUp.confirmPasswordRequired': '请确认您的密码',
    'signUp.confirmPasswordPlaceholder': '请确认您的密码',
    'signUp.passwordsDoNotMatch': '密码不匹配',
    'signUp.verificationCode': '验证码',
    'signUp.codeRequired': '验证码是必填项',
    'signUp.codePlaceholder': '请输入验证码',
    'signUp.codeSent': '验证码已发送到您的邮箱',
    'signUp.sendCode': '发送验证码',
    'signUp.sendCodeFirst': '请先发送验证码',
    'signUp.codeDescription': '验证码将发送到您的邮箱以确认您的注册',
    
    // Auth (shared with signUp/signIn)
    'auth.firstName': '名字',
    'auth.firstNameRequired': '名字是必填项',
    'auth.firstNamePlaceholder': '请输入您的名字',
    'auth.lastName': '姓氏',
    'auth.lastNameRequired': '姓氏是必填项',
    'auth.lastNamePlaceholder': '请输入您的姓氏',
    
    // Sign Up Confirmation
    'signUp.confirmation.title': '账户创建成功！',
    'signUp.confirmation.subtitle': '欢迎来到Pourvoirie Pignon Rouge！',
    'signUp.confirmation.welcome': '欢迎',
    'signUp.confirmation.redirecting': '正在跳转到您的账户...',
  },
};

